import { Box, Container, Stack } from '@mui/material'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { LoginPoster } from '../../components'
import Dashboard from '../../components/Layouts/dashboardLayout'
import { useAuth } from '../../providers'
import PhoneNumberLogin from './components/PhoneNumberLogin'
import { useMobile } from '../../hooks/useMoblie'
const Login = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { isUserLoggedIn } = useAuth()

    useEffect(() => {
        if (isUserLoggedIn) {
            navigate(location?.state?.from || '/bookings')
        }
    }, [isUserLoggedIn, navigate, location])
    const isMobile = useMobile()
    return (
        <Dashboard showDashboard={false}>
            <Container>
                <Stack direction={isMobile ? 'column' : 'row'} alignItems="center" justifyContent="space-evenly">
                    <Box
                        sx={{
                            width: isMobile ? '100%' : '65%',
                        }}
                    >
                        <LoginPoster />
                    </Box>

                    <PhoneNumberLogin />
                </Stack>
            </Container>
        </Dashboard>
    )
}

export default Login
